import { useQuery } from '@tanstack/react-query';

import { listScrapingIntentRuns, type ListScrapingIntentRunsParams } from '../apis';
import { scrapingQueryKeys } from './scraping-query-keys';

export function useScrapingIntentRuns(params: ListScrapingIntentRunsParams, enabled = true) {
  return useQuery({
    queryKey: scrapingQueryKeys.intentRunList(params),
    queryFn: () => listScrapingIntentRuns(params),
    enabled,
  });
}
